import { Injectable } from '@angular/core';

import {
  Action,
  Selector,
  SelectorOptions,
  State,
  StateContext,
} from '@ngxs/store';
import { Observable } from 'rxjs';

import { tap } from 'rxjs/operators';
import { ApiUtilsService } from '../../services';

import { StatisticQueryPresenterModel } from '@osos/shared/types';
import { StatisticQueryFactoryService } from '../../factories/data-statistic-query-factory/statistic-query-factory.service';

import { StatisticQueryDataService } from '../../services/data-services/statistic-query-data-service/statistic-query-data.service';
import { STQueryCoreActions } from './st-query-core.action';

export interface STQueryCoreStateModel {
  transitorySTQueries: StatisticQueryPresenterModel[];
}

@State<STQueryCoreStateModel>({
  name: 'stQueryCore',
  defaults: {
    transitorySTQueries: [],
  },
})
@Injectable()
@SelectorOptions({ injectContainerState: false })
export class STQueryCoreState {
  constructor(
    private apiHelper: ApiUtilsService,
    private statisticQueriesService: StatisticQueryDataService,
    private statisticQueryFactoryService: StatisticQueryFactoryService,
  ) {}

  // --------------------------------- SELECTORS ------------------------------
  @Selector([STQueryCoreState])
  static transitorySTQueries(
    state: STQueryCoreStateModel,
  ): StatisticQueryPresenterModel[] {
    return state.transitorySTQueries;
  }

  // --------------------------------- ACTIONS --------------------------------
  @Action(STQueryCoreActions.TransitoryFetchSTQueries)
  transitoryFetchStatisticQueries(
    ctx: StateContext<STQueryCoreStateModel>,
    { payload }: STQueryCoreActions.TransitoryFetchSTQueries,
  ): Observable<any> {
    return this.statisticQueriesService
      .find({
        entity: payload.entityId,
        filter: this.apiHelper.prepareFilter({
          where: {
            dataEntity: payload.entityId,
            id: { nin: [...payload.excludedIds] },
          },
        }),
      })
      .pipe(
        tap((res) => {
          ctx.patchState({
            transitorySTQueries: res.map((query) =>
              this.statisticQueryFactoryService.createPresenterModel(query),
            ),
          });
        }),
      );
  }
}
